__turbopack_context__.v({
  "actions": "WNewsletter-module__mhDX2G__actions",
  "backdrop": "WNewsletter-module__mhDX2G__backdrop",
  "close": "WNewsletter-module__mhDX2G__close",
  "form": "WNewsletter-module__mhDX2G__form" + " " + __turbopack_context__.i("[project]/components/ui/Form/Form.module.css [app-client] (css module)")["form"],
  "heading": "WNewsletter-module__mhDX2G__heading",
  "modal": "WNewsletter-module__mhDX2G__modal",
  "root": "WNewsletter-module__mhDX2G__root",
  "text": "WNewsletter-module__mhDX2G__text",
});
